export enum RouterCategory {
    V2,
    EQUAL_VEE3,
    SPIRIT_SWAP,
    WIGO_SWAP,
    V4
  }
  